exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clearfix[data-v-c918a4b2]:before,\r\n.clearfix[data-v-c918a4b2]:after {\r\n  display: table;\r\n  content: \"\";\n}\n.clearfix[data-v-c918a4b2]:after {\r\n  clear: both;\n}\r\n", ""]);

// exports
